<template>
  <Mountings variant="passive" />
</template>

<script lang="tsx" setup>
import Mountings from '@pages/mountings/Mountings.vue';
</script>

<style lang="scss" scoped>
</style>
